export const skeleton = () => {
    return [
        {
            row: [33, 9, 58],
            items: [
                {
                    content: [
                        {
                            type: 'title',
                            width: 50
                        },
                        {
                            type: 'blockSM',
                            width: 30
                        },
                        'empty',
                        {
                            type: 'blockSM'
                        },
                        {
                            type: 'blockSM'
                        },
                        'empty',
                        {
                            type: 'text',
                            width: 60
                        },
                        {
                            type: 'blockSM'
                        },
                        {
                            type: 'blockSM'
                        }
                    ]
                },
                'empty',
                {
                    type: 'image',
                    height: '629'
                }
            ]
        }
    ];
};

export const getContactValue = (c) => {
    switch (c.type) {
        case 'tel':
            return `tel:${c.value}`;
        case 'whatsapp':
            return `https://wa.me/${c.value}`;
        case 'telegram':
            return `https://t.me/${c.value}`;
        case 'viber':
            return `viber://chat?number=${c.value}`;
        case 'email':
            return `mailto:${c.value}`;
        case 'skype':
            return `skype:${c.value}`;
        case 'facebook':
            return `https://www.facebook.com/${c.value}`;
        case 'instagram':
            return `https://www.instagram.com/${c.value}`;
        case 'twitter':
            return `https://twitter.com/${c.value}`;
        case 'clubhouse':
            return `https://www.joinclubhouse.com/${c.value}`;
        case 'tiktok':
            return `https://www.tiktok.com/${c.value}`;
        case 'vk':
            return `https://vk.com/${c.value}`;
        case 'ok':
            return `https://ok.ru/${c.value}`;
        default:
            return '/';
    }
};

export const setCenter = (center, setSelectedCenter = () => {}) => {
    const phone_contacts = ['whatsapp', 'telegram', 'viber'];
    const messengers = ['facebook', 'instagram', 'twitter', 'vk', 'ok', 'tiktok', 'clubhouse'];

    const transformedCenter = {
        ...center,
        contacts: center.contacts
            ?.map((contact) => {
                if (contact.type === 'tel') {
                    return {
                        ...contact,
                        messengers: center?.contacts?.filter((c) => phone_contacts.includes(c.type))
                    };
                }
                if (phone_contacts.includes(contact.type)) return;
                return contact;
            })
            .filter((el) => !!el),
        address: [center?.country?.name, center?.city?.name, center?.address]?.filter((el) => !!el)?.join(', '),
        messengers: messengers.filter((mes) => center[mes])?.map((mes) => ({ type: mes, value: center[mes] }))
    };

    setSelectedCenter && typeof setSelectedCenter === 'function' && setSelectedCenter(transformedCenter);
    return transformedCenter;
};
